'use client'

import { Link } from '@/components/Link'
import Typography from '@/components/Typography/Typography'
import { toKebabCase } from '@/utils/string'
import { getLinkPathname } from '@/utils/urls'
import { showRepublishingHint } from '@/elements/widgets/Article/ArticleDetailHead'
import styles from './ArticleDetailFooter.module.scss'
import AppContext from '@/types/context'

type FooterWidgetContext = {
  readonly items: ReadonlyArray<{
    readonly id: string
    readonly model: FooterProps
  }>
}

type FooterProps = {
  readonly id: string
  readonly publishedAt: string
  readonly lastmodifiedAt: string
  readonly republishing: boolean
  readonly source?: string
  readonly 'source-default'?: boolean
  readonly tagpages?: Array<{
    readonly label: string
    readonly url: string
  }>
}

const Tags = ({ footerProps }: { footerProps: FooterProps }) => (
  <>
    {footerProps.tagpages && footerProps.tagpages.length > 0 && (
      <div className={styles.tags} data-cy={`article-detail-footer-${footerProps.id}-tags`}>
        {footerProps.tagpages?.map((tag, index) => (
          <Link href={getLinkPathname(tag.url)} title={tag.label} key={toKebabCase(tag.label) + index}>
            <Typography as="span" variant="s" weight="bold">
              {tag.label}
            </Typography>
          </Link>
        ))}
      </div>
    )}
  </>
)

const Source = ({ footerProps }: { footerProps: FooterProps }) => {
  const source = footerProps.source
  const sourceNtv = footerProps['source-default']

  if (sourceNtv && source) {
    return (
      <div
        className={styles.source}
        data-cy={`article-detail-footer-${footerProps.id}-source`}
      >{`Verwendete Quellen: ntv.de, ${footerProps.source}`}</div>
    )
  } else if (sourceNtv && !source) {
    return (
      <div className={styles.source} data-cy={`article-detail-footer-${footerProps.id}-source`}>
        Verwendete Quelle: ntv.de
      </div>
    )
  } else if (source) {
    return (
      <div
        className={styles.source}
        data-cy={`article-detail-footer-${footerProps.id}-source`}
      >{`Verwendete Quellen: ${source}`}</div>
    )
  }

  return <></>
}

const ArticleDetailFooter = ({ item, context }: { item: FooterWidgetContext; context: AppContext }) => {
  const footerProps: FooterProps = item.items?.[0]?.model
  return (
    <>
      {footerProps && (
        <>
          <Source footerProps={footerProps} />
          {!context.webview && <Tags footerProps={footerProps} />}
        </>
      )}
    </>
  )
}

export default ArticleDetailFooter
